export default __webpack_public_path__ + "static/media/9.4b6ab6c0.webp";